const statusList = [
	{
		key: 'DEVELOPMENT',
		value: 'Development',
		type: 'STATUS'
	},
	{
		key: 'COMPLETE_AND_PUBLISHED',
		value: 'Complete & Published',
		type: 'STATUS'
	}
];

const filterCategory = [
	{
		key: 'MINE',
		value: 'Mine',
		type: 'FILTER_CATEGORY'
	},
	{
		key: 'SHARED',
		value: 'Shared',
		type: 'FILTER_CATEGORY'
	}
];

const collectionStatusList = [
	{
		key: 'INITIAL',
		value: 'Initial',
		color: 'color1'
	},
	{
		key: 'DEVELOPMENT',
		value: 'Development',
		color: 'color2'
	},
	{
		key: 'COMPLETE',
		value: 'Complete',
		color: 'color3'
	}
];

const criteriaList = [
	{
		key: 'PUBLISHED',
		value: 'Published'
	},
	{
		key: 'UPCOMING',
		value: 'Upcoming'
	},
	{
		key: 'CUSTOMERS',
		value: 'Customers'
	}
];

const objForDateRange = {
	valName: 'dateRangePicker',
	type: 'dateRange',
	title: 'Creation date',
	paramName1: 'fromDate',
	paramName2: 'toDate',
	value1: '',
	value2: ''
};
const objForPublishDate = {
	valName: 'publishDateRangePicker',
	type: 'dateRange',
	title: 'Publish date',
	paramName1: 'publishDateFrom',
	paramName2: 'publishDateTo',
	value1: '',
	value2: ''
};

const objForBuyerEtdDateRange = {
	valName: 'dateRangePicker',
	type: 'dateRange',
	title: 'Buyer ETD',
	paramName1: 'buyerEtdFrom',
	paramName2: 'buyerEtdTo',
	value1: '',
	value2: ''
};

const objForPODateRange = {
	valName: 'poReceivedDate',
	type: 'dateRange',
	title: 'PO Received Date',
	paramName1: 'poReceivedDateFrom',
	paramName2: 'poReceivedDateTo',
	value1: '',
	value2: ''
};

const publicCollections = [
	{
		key: true,
		value: 'YES'
	},
	{
		key: false,
		value: 'NO'
	}
];

const supplierTypeWiseList = {
	fabricCategory: true,
	fabricSubCategory: true,
	composition: true,
	brand: true,
	gsm: true
};

const embellishmentList = {
	embellishmentCategory: true,
	fabricSubCategory: true
};

const trimWiseFilterList = {
	trimsCategories: true,
	itemType: true,
	trimsComposition: true
};

const accessoriesWiseFilterList = {
	accessoriesCategory: true,
	itemType: true,
	trimsComposition: true
};

const washingFilterList = {
	washProcesses: true
};

const collectionFieldList = {
	mineAndShared: true,
	createdBy: true,
	brand: true,
	collectionMember: true,
	status: true,
	season: true,
	creationDate: true
};

const favouriteListFieldList = {
	mineAndShared: true,
	createdBy: true,
	brand: true,
	creationDate: true
};

const designFieldList = {
	styleTracker: true,
	lastStatus: true,
	mineAndShared: true,
	market: true,
	blockCategory: true,
	fabricTypeV2: true,
	brand: true,
	status: true,
	developmentLocation: true,
	productionPrice: true,
	offerPrice: true,
	season: true,
	creationDate: true,
	publishDate: true,
	team: true
};

const collectionDetailsFieldList = {
	styleTracker: true,
	lastStatus: true,
	market: true,
	blockCategory: true,
	collection: true,
	fabricTypeV2: true,
	date: true,
	tag: true,
	publish: true,
	status: true,
	productionPrice: true,
	collectionLocation: true,
	team: true,
	collectionLocationUpdate: true
};

const orderDashboardFieldList = {
	brand: true,
	styleNumber: true,
	tnaStatus: true,
	salesChannel: true,
	accountManager: true,
	projectManager: true,
	nitexDesign: true,
	merchandiser: true,
	poNumber: true,
	poReceivedDate: true,
	buyerEtd: true,
	orderTitle: true,
	orderStage: true,
	factory: true,
	salesContract: true,
	commercialInvoice: true
};
const CRMTargetFilterFieldList = {
	crmMyTeam: true
};

const materialRequisitionFilterFieldList = {
	purpose: true,
	brand: true,
	trendCategory: true,
	createdBy: true,
	status: true,
	requestedDate: true,
	requiredDate: true
};

const materialRequisitionTrimsAndAccessoriesFilterFieldList = {
	purpose: true,
	brand: true,
	createdBy: true,
	status: true,
	requestedDate: true,
	requiredDate: true
};

const orderPageFieldList = {
	accountManager: true,
	brand: true,
	entryState: true,
	projectManager: true,
	revenueStream: true,
	salesChannel: true
};

const orderDashboardPageList = {
	brand: true,
	market: true,
	blockCategory: true,
	fabricTypeV2: true,
	designBy: true,
	poNumber: true,
	orderTitle: true,
	supplierList: true,
	salesContract: true,
	commercialInvoiceNumber: true,
	date: true,
	orderStage: true,
	tnaStatus: true,
	revenueStream: true,
	accountManager: true,
	projectManager: true,
	merchandiser: true
};

const trendResearchBrandFilterFieldList = {
	brandCategory: true,
	market: true,
	fabricType: true,
	trendCategory: true,
	trendResearchComposition: true,
	fiber: true,
	aop: true,
	graphics: true,
	color: true
};

const trendResearchInstagramFilterFieldList = {
	influencerList: true,
	market: true,
	trendCategory: true,
	aop: true,
	graphics: true,
	color: true
};

const adminPageFieldList = {
	email: true,
	role: true,
	department: true
};

const teamPageFieldList = {
	department: true,
	teamLead: true,
	teamMember: true
};

const supplierListFilterFields = {
	supplierGrade: true,
	supplierType: true,
	supplierStatus: true,
	fabricType: true,
	location: true,
	brand: true,
	certificate: true,
	certificateStrength: true,
	audit: true,
	priceRange: true,
	expiry: true
};

const salesFunnelFilterFields = {
	brand: true,
	accountManager: true,
	teamMember: true,
	brandApprover: true,
	probability: true,
	stages: true,
	costingStatus: true,
	sampleStatus: true,
	overDue: true,
	department: true,
	productCategory: true,
	designedBy: true,
	dateRange: true,
	requestedDate: true,
	poReceivedDate: true
};

const sampleListFilterFields = {
	brand: true,
	sampleStatus: true,
	fabricType: true,
	market: true,
	requestedBy: true,
	placement: true,
	collection: true,
	designedBy: true,
	supplierList: true,
	fabricSupplierList: true,
	requestedDate: true,
	requiredDate: true
};

const sampleDetailsFilterFields = {
	sampleStatus: true,
	market: true,
	category: true,
	fabricType: true,
	requiredDate: true,
	submissionPlanDate: true
};

const costingListFilterFields = {
	brand: true,
	costingStatus: true,
	fabricType: true,
	market: true,
	category: true,
	collection: true,
	designedBy: true,
	requestedBy: true,
	requestedDate: true,
	requiredDate: true,
	supplierList: true
};

const costingListDesignStudioFields = {
	blockCategory: true,
	composition: true,
	fabricTypeV2: true,
	lastModifiedDate: true,
	market: true,
	requestedBy: true,
	publishDate: true
};

const initialCostingListFilterFields = {
	brand: true,
	collection: true,
	requestedBy: true
};

const costingDetailsFilterFields = {
	fabricType: true,
	market: true,
	category: true,
	costingStatus: true,
	requiredDate: true
};

const pomListFilterFields = {
	bodyParts: true,
	brand: true,
	category: true,
	market: true,
	pomSize: true,
	side: true,
	verticalOrHorizontal: true
};
const blockSuggestionsFilterFields = {
	market: true,
	blockCategory: true,
	fittingType: true,
	rise: true,
	length: true,
	brand: true,
	blockCreatedBy: true
};

const blockLibraryDesignFields = {
	market: true,
	blockCategory: true,
	brand: true,
	fittingType: true,
	rise: true,
	length: true,
	region: true,
	createdBy: true
};

const blockLibraryCollectionFields = {
	brand: true,
	createdBy: true
};
const myColleaguesFilterFields = {
	designation: true,
	stackholder: true,
	teamLead: true
};

const fabricFilterFields = {
	fabricTypeV2: true,
	composition: true,
	weight: true,
	multilayerColors: true,
	pattern: true,
	finishAndWash: true,
	characteristics: true,
	country: true,
	base: true,
	brand: true,
	priceRangeV2: true,
	supplierV2: true,
	notUsedSince: true,
	fabricBalance: true,
	importedOrLocal: true
};

const trimsFilterFields = {
	materialCategory: true,
	materialQuality: true,
	multilayerColors: true,
	sustainability: true,
	brandSpecific: true,
	supplierV2: true
};

const sketchListFields = {
	blockCategory: true,
	fittingType: true,
	rise: true,
	length: true,
	createdBy: true
};

const arkworkListFields = {
	season: true,
	theme: true,
	tag: true,
	team: true,
	creationDate: true
};

const clientListFields = {
	brand: true,
	accountManager: true,
	status: true
};

const projectDetailsFilterFields = {
	owner: true,
	status: true
};

const myProjectsFilterFields = {
	owner: true,
	projectDueDate: true,
	PROJECT_STATUS: true,
	brand: true
};

const categoryTypeParamsBasedOnSupplier = {
	GARMENTS: 'productCategoryIds',
	FABRIC: 'constructionIdList',
	TRIMS: 'trimsCategoryList',
	ACCESSORIES: 'brandingCategoryList'
};

const filterFieldType = {
	GRADE: { title: 'Supplier Rank', idName: 'supplierGradingList' },
	SUPPLIER_TYPE: { title: 'Supplier Type', idName: 'supplierType' },
	SUPPLIER_STATUS: { title: 'Supplier Status', idName: 'supplierStatusList' },
	FABRIC_TYPE: { title: 'Fabric type', idName: 'supplierCategoryList' },
	LOCATION: { title: 'Location' },
	CERTIFICATE: { title: 'Compliance', idName: 'certificateTypeList' },
	CERTIFICATE_STRENGTH: {
		title: 'Compliance Grade',
		idName: 'certificateStrengthList'
	},
	AUDIT: { title: 'Audit', idName: 'isAudit' },
	PRICE_RANGE: { title: 'Price Range', idName: 'pricePointList' },
	PRODUCT_CATEGORY: { title: 'Product Category', idName: 'categoryIdList' },
	COLOR_TYPE: { title: 'Color Type', idName: 'colorTypeList' },
	DATE_RANGE: { title: 'Expected Order Date', idName: 'dateRange' },
	ACCOUNT_MANAGER: { title: 'Account Manager', idName: 'accountManagerIdList' },
	BRAND_APPROVER: { title: 'Brand Approver', idName: 'brandApproverIdList' },
	COSTING_STATUS: { title: 'Costing Status', idName: 'costingStatusList' },
	DESIGNED_BY: { title: 'Designed By', idName: 'designByNitex' },
	DEPARTMENT: { title: 'Department', idName: 'productGroupIdList' },
	OVERDUE: { title: 'Overdue', idName: 'overdueByProductStageList' },
	PO_RECEIVED_DATE: { title: 'PO Receive Date', idName: 'poReceivedDate' },
	PROBABILITY: { title: 'Probability', idName: 'probabilityList' },
	SAMPLE_STATUS: { title: 'Sample Status', idName: 'sampleStatusList' },
	STAGE_LIST: { title: 'Stage', idName: 'stageList' },
	TEAM_MEMBER: { title: 'Team Member', idName: 'teamMemberIdList' },
	MARKET: { title: 'Market', idName: 'marketIds' },
	CATEGORY: { title: 'Category', idName: 'categoryIds' },
	COLLECTION: { title: 'Collection', idName: 'collectionIds' },
	FACTORY: { title: 'Factory', idName: 'factoryIds' },
	FABRIC_SUPPLIER: { title: 'Fabric Supplier', idName: 'fabricSupplierIds' },
	REQUESTED_DATE: { title: 'Requested Date', idName: 'requestDate' },
	REQUIRED_DATE: { title: 'Required Date', idName: 'requiredDate' },
	SUBMISSION_PLAN_DATE: {
		title: 'Submmision Plan Date',
		idName: 'submissionPlanDate'
	},
	REQUESTED_BY: { title: 'Requested By', idName: 'requestByIds' },
	PLACEMENT: { title: 'Placement', idName: 'operationalUnitId' },
	BODY_PARTS: { title: 'Body Parts', idName: 'bodyPartList' },
	POM_SIZE: { title: 'POM Size', idName: 'sizeList' },
	SIDE: { title: 'Side', idName: 'sideList' },
	POSITION_LIST: { title: 'Vertical/Horizontal', idName: 'positionList' },
	BLOCK_NAME: { title: 'Block name' },
	FITTING_TYPE: { title: 'Fitting type', idName: 'fittingTypeTagIds' },
	RISE: { title: 'Rise', idName: 'riseTagIds' },
	LENGTH: { title: 'Length', idName: 'lengthTagIds' },
	REGION: { title: 'Region', idName: 'sizeStandardTagIds' },
	CREATED_BY: { title: 'Created by', idName: 'createdByIds' },
	BLOCK_CREATED_BY: { title: 'Block created by', idName: 'blockCreatedById' },
	BLOCK_CATEGORY: { title: 'Category', idName: 'blockCategory' },
	BLOCK_SUB_CATEGORY: { title: 'Sub Category', idName: 'blockSubCategory' },
	MOOD: { title: 'Mood', idName: 'moodIds' },
	ARTWORK_PATTERN: { title: 'Artwork pattern', idName: 'patternIds' },
	TAG: { title: 'Tag', idName: 'tagIds' },
	DESIGNATION: { title: 'Designation', idName: 'designationIds' },
	STACKHOLDER: { title: 'Stakeholder', idName: 'stackholderIds' },
	TEAM_LEAD: { title: 'Team Lead', idName: 'teamLeadIds' },
	COMPOSITION: {
		title: 'Composition',
		idName: 'fabricCompositionPartSearchDtoList'
	},
	WEIGHT: { title: 'Weight', idName: 'washProcesses' },
	COLOR: { title: 'Color', idName: 'colorList' },
	FINISH_AND_WASH: { title: 'Finish and wash', idName: 'finishAndWashIds' },
	CHARACTERISTICS: { title: 'Characteristics', idName: 'characteristicIds' },
	COUNTRY: { title: 'Supplier location', idName: 'countryIds' },
	BASE: { title: 'Base', idName: 'baseList' },
	NITEX_REFERENCE: { title: 'Nitex reference', idName: 'nitexReferenceIds' },
	BRAND: { title: 'Brand', idName: 'brandIds' },
	FABRIC_TYPE_V2: { title: 'Fabric Type', idName: 'constructions' },
	FABRIC_TYPE_V2_SUB_CATEGORY: {
		title: 'Fabric type sub category',
		idName: 'constructions'
	},
	SUPPLIER: { title: 'Supplier', idName: 'suppliers' },
	IMPORTED_OR_LOCAL: { title: 'Imported or local', idName: 'IS_IMPORTED' },
	PRICE_RANGE_V2: { title: 'Price range', idName: 'pricePointList' },
	SEASON: { title: 'Season', idName: 'seasonList' },
	THEME: { title: 'Theme', idName: 'themeList' },
	STATUS: { title: 'Status', idName: 'filterSubCategoryList' },
	COLLECTION_MEMBER: { title: 'Collection member', idName: 'memberIdList' },
	DEVELOPMENT_LOCATION: { title: 'Development location', idName: 'developmentLocationList' },
	MINE_AND_SHARED: { title: 'Mine & Shared', idName: 'filterCategoryList' },
	CREATION_DATE: { title: 'Creation Date ', idName: 'creationDate' },
	PUBLISH_DATE: { title: 'Publish Date', idName: 'publishDate' },
	PRODUCTION_PRICE: { title: 'Production Price', idName: 'productionPriceDtoList' },
	OFFER_PRICE: { title: 'Offer Price', idName: 'offerPriceDtoList' },
	LAST_MODIFIED_DATE: { title: 'Last Modified', idName: 'lastModifiedDate' },
	NOT_USED_SINCE: { title: 'Not used since', idName: 'notUsedSince' },
	FABRIC_BALANCE: { title: 'Fabric Balance', idName: 'fabricBalance' },
	MATERIAL_QUALITY: { title: 'Material quality ', idName: 'materialQualityIds' },
	MULTILAYER_COLORS: { title: 'Color ', idName: 'colorGroupList' },
	PATTERN: { title: 'Solid/Pattern ', idName: 'fabricPatternIds' },
	SUSTAINABILITY: { title: 'Sustainability ', idName: 'sustainabilityIds' },
	BRAND_SPECIFIC: { title: 'Brand specific ', idName: 'specificBrandIds' },
	MATERIAL_CATEGORY: { title: 'Category ', idName: 'subCategoryIds' },
	COLLECTION_LOCATION: { title: 'Location', idName: 'collectionLocationList' },
	DATE: { title: 'Date', idName: 'dateList' },
	TEAM: { title: 'Team', idName: 'teamList' },
	PROJECT_MANAGER: { title: 'Project Manager', idName: 'projectManagerIdList' },
	REVENUE_STREAM: { title: 'Revenue Stream', idName: 'streamList' },
	ENTRY_STATE: { title: 'Entry State', idName: 'isDraftedList' },
	TNA_STATUS: { title: 'TNA Status', idName: 'tnaStatusList' },
	MERCHANDISER: { title: 'Merchandiser (MR)', idName: 'merchandiserIdList' },
	PO_NUMBER: { title: 'PO Number', idName: 'poNumberList' },
	BUYER_ETD: { title: 'Buyer ETD', idName: 'buyerETD' },
	FACTORY_ETD: { title: 'Factory ETD', idName: 'factoryETD' },
	DATE_GROUPS: { title: 'Dates', idName: 'dateGroups' },
	ORDER_TITLE: { title: 'Order Title', idName: 'orderIdList' },
	ORDER_STAGE: { title: 'Order Stage', idName: 'orderStatusList' },
	COMMERCIAL_INVOICE_NUMBER: { title: 'Commercial Invoice No', idName: 'commercialInvoiceNoList' },
	SALES_CONTRACT: { title: 'Sales Contract', idName: 'salesContractIdList' },
	DESIGN_BY: { title: 'Design By', idName: 'designByList' },
	OWNER: { title: 'Owner', idName: 'ownerList' },
	TREND_COMPOSITION: { title: 'Composition', idName: 'keyCompositionList' },
	TREND_GRAPHICS: { title: 'Graphics', idName: 'graphicsContentList' },
	TREND_FIBER: { title: 'Fiber', idName: 'fiberList' },
	TREND_AOP: { title: 'AOP', idName: 'graphicsTypeList' },
	TREND_CATEGORY: { title: 'Category', idName: 'categoryIdList' },
	TREND_BRAND_CATEGORY: { title: 'Brand Category', idName: 'brandCodeList' },
	TREND_INFLUENCER: { title: 'Influencer', idName: 'userNameList' },
	TREND_THEME: { title: 'Theme', idName: 'themeList' },
	MATERIAL_STATUS: { title: 'Status', idName: 'status' },
	PURPOSE: { title: 'Purpose', idName: 'purposeList' },
	EX_FACTORY_DATE: { title: 'Ex Factory Date', idName: 'exFactoryDate' },
	INVENTORY_UPDATE: {
		title: 'Location update status',
		idName: 'locationUpdateStatusList'
	},
	PROJECT_TYPE: {
		title: 'Project Type',
		idName: 'projectType'
	},
	PROJECT_DUE_DATE: {
		title: 'Project due date',
		idName: 'projectDueDate'
	},
	LAST_STATUS: {
		title: 'Last Status',
		idName: 'lastStatusList'
	},
	STYLE_TRACKER: {
		title: 'Style Tracker',
		idName: 'taskGroupList'
	},
	PROJECT_STATUS: {
		title: 'Project status',
		idName: 'statusList'
	},
	EXPIRY: {
		title: 'Expiry',
		idName: 'expiryList'
	},
	// TODO: Sync with backend params for this field
	SOLD_DATE: {
		title: 'Sold date',
		idName: 'soldDate'
	}
};

const toggleCheckbox = (filterData, fieldName, fieldIdentifier) => {
	if (filterData) {
		let selectedField;
		if ([fieldName] in filterData) {
			selectedField =
				filterData[fieldName]?.find((field) => field.identifier === fieldIdentifier) || null;
		}
		if (selectedField) {
			if (selectedField?.checked) return true;
			return false;
		} else return false;

		// if (!value) {
		// 	return selectedField !== undefined;
		// } else {
		// 	return selectedField !== undefined && selectedField.key === value.toString();
		// }
	}
};

const getFilterTextFieldValue = (filterData, fieldName, fieldIdentifier) => {
	let selectedField;
	if ([fieldName] in filterData) {
		selectedField = filterData[fieldName]?.find((field) => field.identifier === fieldIdentifier);
	}
	return selectedField;
};

const onUnSelectAllStatus = (filterData) => {
	const data = filterData?.status;
	return data?.length === 1 && data[0]?.key === 'Development' && data[0]?.type === 'SELECT' ? true : false;
};

const generateDateRangeParamsForDesign = (filterData, field, dateRangeData, params) => {
	filterData[field].forEach((item) => {
		if (item.type === 'dateRange') {
			let date = item.key.split(',');
			if (item?.identifier === 'collectionFilterDateRange') {
				if (dateRangeData.length > 0) dateRangeData += `fromDate=${date[0]}&toDate=${date[1]}`;
				else dateRangeData += `fromDate=${date[0]}&toDate=${date[1]}&`;
			}
			if (item?.identifier === 'collectionFilterPublishDateRange') {
				if (dateRangeData.length > 0)
					dateRangeData += `publishDateFrom=${date[0]}&publishDateTo=${date[1]}`;
				else dateRangeData += `publishDateFrom=${date[0]}&publishDateTo=${date[1]}&`;
			}
		}
	});
	let dateParams = params + dateRangeData + '&';
	if (dateParams.charAt(dateParams.length - 2) === '&') {
		params = dateRangeData.substring(0, dateRangeData.length - 1) + '&';
	} else params = dateParams;
	return params;
};

const generateFilterParams = (filterData) => {
	let queryParams = '';
	let designFilterFields = '';
	let filterCategory = '';
	let status = '';
	let dateRangeData = '';

	for (let field in filterData) {
		if (Array.isArray(filterData[field])) {
			let params = '';
			if (field !== 'dateRange') {
				params = field + '=';
			}
			if (field === 'dateRange') {
				params = generateDateRangeParamsForDesign(filterData, field, dateRangeData, params);
			} else {
				filterData[field].forEach((item) => {
					if (item.name === 'filterCategory') {
						filterCategory += item.key + ',';
						params = `filterCategory=${filterCategory}`;
					} else if (item.name === 'status') {
						if (onUnSelectAllStatus(filterData)) {
							params = `status=${item.value},`;
						} else {
							if (item.type === 'FILTER') {
								status += item.key + ',';
								params = `status=${status}`;
							} else if (item.type === 'SELECT' && item.key !== 'Development') {
								status += item.value + ',';
								params = `status=${status}`;
							}
						}
					} else if (item.name === 'filterBy') {
						designFilterFields += item.key + ',';
						params = `filterBy=${designFilterFields}`;
					} else {
						if (item?.name === 'name') {
							params += encodeURIComponent(item.key) + ',';
						} else {
							params += item.key + ',';
						}
					}
				});
			}

			params = params.substring(0, params.length - 1);
			queryParams += params + '&';
		}
	}
	return queryParams;
};

const generateTeamParams = (myTeamMembers, params) => {
	if (myTeamMembers.isMy) {
		params += `&isMy=${myTeamMembers.isMy}`;
	}
	if (myTeamMembers.isTeam) {
		params += `&isTeam=${myTeamMembers.isTeam}`;
	}
	if (myTeamMembers.selectedUsers.length > 0) {
		let ids = myTeamMembers.selectedUsers?.map((item) => item.id);
		params += `&teamIds=${ids.join(',')}`;
	}
	return params;
};

const isTeamFilterExist = (myTeamMembers) => {
	return myTeamMembers.isMy || myTeamMembers.isTeam || myTeamMembers.selectedUsers.length > 0;
};

const generateOrderDashboardParams = (filterData) => {
	let queryParams = '';
	let paymentDocumentTypeList = [];
	const fieldMappings = {
		brandId: 'brandIdList=',
		brandIds: 'brandIdList=',
		poIdList: 'rfqIdList=',
		factoryIds: 'factoryIdList=',
		marketIds: 'marketIdList=',
		blockCategory: 'subCategoryIdList=',
		constructions: 'fabricConstructionList='
	};

	for (let field in filterData) {
		if (Array.isArray(filterData[field])) {
			let params = fieldMappings[field] || `${field}=`;
			filterData[field].forEach((item) => {
				if (item.value !== 'All') {
					if (['poReceivedDate', 'buyerETD', 'exFactoryDate', 'factoryETD'].includes(item.name)) {
						let date = item.key.split(',');
						params = `${item.name}From=${date[0]}&${item.name}To=${date[1]},`;
					} else if (item.name === 'name') {
						params = `search=${encodeURIComponent(item.key)},`;
					} else if (item.name === 'orderStatus') {
						if (item.key !== 'SALES_CONTRACT' && item.key !== 'PROFORMA_INVOICE') {
							params += item.key + ',';
						}
						if (item.key === 'SALES_CONTRACT') {
							paymentDocumentTypeList.push('SALES_CONTRACT');
						}
						if (item.key === 'PROFORMA_INVOICE') {
							paymentDocumentTypeList.push('PROFORMA_INVOICE');
						}
					} else if (item.name === 'constructions') {
						params += item.value + ',';
					} else {
						params += item.key + ',';
					}
				}
			});
			params = params.substring(0, params.length - 1);
			queryParams += params + '&';
			if (field === 'nitexDesign') {
				if (filterData['nitexDesign'].length === 1) {
					queryParams += `isNitexDesign=${filterData['nitexDesign'][0].key === 'yes'}&`;
				}
			}
		}
	}
	if (paymentDocumentTypeList.length > 0) {
		queryParams += 'paymentDocumentTypeList=' + paymentDocumentTypeList.join(',') + '&';
	}

	return queryParams.length > 0 ? '&' + queryParams.slice(0, -1) : '';
};

const supplierTypeWiseFieldParams = (supplierType, filterFields, pageNumber = 0) => {
	let params = `?page=${pageNumber}&size=20&supplierType=${supplierType}`;
	if (Object.keys(filterFields).length > 0) {
		if (filterFields?.fabricTypes) {
			let fieldName = 'fabricTypes';
			if (supplierType === 'TRIMS') {
				fieldName = 'trimsCategories';
			} else if (supplierType === 'ACCESSORIES') {
				fieldName = 'brandingCategories';
			} else if (supplierType === 'EMBELLISHMENT') {
				fieldName = 'embellishmentCategories';
			}
			params += `&${fieldName}=${filterFields.fabricTypes.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.trimsCategories) {
			params += `&trimsCategories=${filterFields.trimsCategories.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.compositions) {
			params += `&compositions=${filterFields.compositions.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.brandingCategories) {
			params += `&brandingCategories=${filterFields.brandingCategories
				.map((item) => item.key)
				.join(',')}`;
		}
		if (filterFields?.embellishmentCategories) {
			params += `&embellishmentCategories=${filterFields.embellishmentCategories
				.map((item) => item.key)
				.join(',')}`;
		}
		if (filterFields?.constructions) {
			params += `&constructions=${filterFields.constructions.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.fabricCompositionPartIdList) {
			params += `&fabricCompositionPartIdList=${filterFields.fabricCompositionPartIdList
				.map((item) => item.key)
				.join(',')}`;
		}
		if (filterFields?.brandId) {
			params += `&brandIdList=${filterFields.brandId.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.minGsm) {
			params += `&minGsm=${filterFields.minGsm.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.maxGsm) {
			params += `&maxGsm=${filterFields.maxGsm.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.name) {
			params += `&search=${filterFields.name.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.washProcesses) {
			params += `&washProcesses=${filterFields.washProcesses.map((item) => item.key).join(',')}`;
		}
		if (filterFields?.type) {
			let fieldName = supplierType === 'TRIMS' ? 'trimsTypes' : 'brandingTypes';
			params += `&${fieldName}=${filterFields.type.map((item) => item.key).join(',')}`;
		}
	}
	return params;
};

const generateSupplierListParams = (filters, page) => {
	let newFilters = { page, size: 20 };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
		}
	}
	if (!filters.sort) {
		newFilters['sort'] = 'gradingMark,desc';
	}
	return { ...newFilters };
};

const dateParamsName = {
	dateRange: { startDate: 'startDate', endDate: 'endDate' },
	requestDate: { startDate: 'requestDateStart', endDate: 'requestedDateEnd' },
	requiredDate: { startDate: 'requiredDateStart', endDate: 'requiredDateEnd' },
	submissionPlanDate: {
		startDate: 'submissionPlanDateStart',
		endDate: 'submissionPlanDateEnd'
	},
	requestedDateStart: {
		startDate: 'requestedDateStart',
		endDate: 'requestedDateEnd'
	},
	salesFunnelRequestDate: {
		startDate: 'requestStartDate',
		endDate: 'requestEndDate'
	},
	poReceivedDate: {
		startDate: 'poReceiveStartDate',
		endDate: 'poReceiveEndDate'
	},
	creationDate: {
		startDate: 'fromDate',
		endDate: 'toDate'
	},
	creationDateForProduct: {
		startDate: 'creationFromDate',
		endDate: 'creationUptoDate'
	},
	publishDate: {
		startDate: 'publishDateFrom',
		endDate: 'publishDateTo'
	},
	publishDateForCosting: {
		startDate: 'minPublishDate',
		endDate: 'maxPublishDate'
	},
	lastModifiedDate: {
		startDate: 'minLastModifiedDate',
		endDate: 'maxLastModifiedDate'
	},
	buyerEtd: {
		startDate: 'buyerETDFrom',
		endDate: 'buyerETDTo'
	},
	factoryETD: {
		startDate: 'factoryETDFrom',
		endDate: 'factoryETDTo'
	}
};

const formatDateParams = (filters, newFilters, property, newProperty = null) => {
	const dateKey = dateParamsName[newProperty || property];
	const splitDate = filters[property]?.[0]?.key?.split(',');

	if (!splitDate) return newFilters;
	const startDate = splitDate[0];
	const endDate = splitDate[1] || startDate;

	newFilters[dateKey.startDate] = startDate;
	newFilters[dateKey.endDate] = endDate;

	delete newFilters[property];
	return newFilters;
};

const renameFieldParams = (filters, newFilters, property, newProperty) => {
	let value = filters[property]?.map((item) => item.key);
	newFilters[newProperty] = value;
	delete newFilters[property];
	return newFilters;
};

const generateSalesFunnelDashboardParams = (filters, addRejectedParams = false) => {
	let newFilters = {};
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => {
				if (property === 'designByNitex') {
					return item.key === '1';
				} else {
					return item.key;
				}
			});
			if (property === 'dateRange') {
				formatDateParams(filters, newFilters, 'dateRange');
			}
			if (property === 'requestDate') {
				formatDateParams(filters, newFilters, 'requestDate', 'salesFunnelRequestDate');
			}
			if (property === 'poReceivedDate') {
				formatDateParams(filters, newFilters, 'poReceivedDate');
			}
		}
	}
	if (!filters.sort) {
		newFilters['sort'] = 'id,desc';
	}
	if (filters?.name?.[0]?.key) {
		newFilters['search'] = filters?.name[0]?.key;
		delete newFilters['name'];
	}
	if (addRejectedParams) {
		let isRejectedSelected = filters?.probabilityList?.find((item) => item.key === 'REJECTED');
		newFilters['showRejected'] = !!isRejectedSelected;
	}
	return { ...newFilters };
};

const generateSampleListParams = (filters, page) => {
	let newFilters = { page, size: 20 };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
			if (property === 'requestDate') {
				formatDateParams(filters, newFilters, 'requestDate', 'requestedDateStart');
			}
			if (property === 'requiredDate') {
				formatDateParams(filters, newFilters, 'requiredDate');
			}
			if (property === 'sampleStatusList') {
				renameFieldParams(filters, newFilters, 'sampleStatusList', 'activityTypes');
			}
			if (property === 'fabricTypeList') {
				renameFieldParams(filters, newFilters, 'fabricTypeList', 'fabricTypes');
			}
		}
	}
	if (!filters.sort) {
		newFilters['sort'] = 'id,desc';
	}
	return { ...newFilters };
};

const generateSampleDetailsParams = (allFilters) => {
	const filters = allFilters?.DETAILS_PAGE_FILTERS;
	let newFilters = {};
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
			if (property === 'submissionPlanDate') {
				formatDateParams(filters, newFilters, 'submissionPlanDate');
			}
			if (property === 'requestDate') {
				formatDateParams(filters, newFilters, 'requestDate', 'requestedDateStart');
			}
			if (property === 'requiredDate') {
				formatDateParams(filters, newFilters, 'requiredDate');
			}
			if (property === 'sampleStatusList') {
				renameFieldParams(filters, newFilters, 'sampleStatusList', 'activityTypes');
			}
			if (property === 'fabricTypeList') {
				renameFieldParams(filters, newFilters, 'fabricTypeList', 'fabricTypes');
			}
		}
	}
	return { ...newFilters };
};

const generateCostingListParams = (filters, status, page, sortId) => {
	let newFilters = { page, size: 20 };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			if (property === 'search') {
				newFilters[property] = filters[property].map((item) => item?.value).join(',');
			} else if (property === 'constructions') {
				newFilters[property] = filters[property].map((item) => item?.value);
			} else {
				newFilters[property] = filters[property].map((item) => {
					if (property === 'fabricCompositionPartSearchDtoList') {
						const result = {
							minPercentage: item?.minPercentage,
							maxPercentage: item?.maxPercentage,
							fiberName: item?.fiberName
						};

						return result;
					} else {
						return item.key;
					}
				});
			}
			if (property === 'brandIds') {
				renameFieldParams(filters, newFilters, 'brandIds', 'brandIdList');
			}
			if (property === 'categoryIds') {
				renameFieldParams(filters, newFilters, 'categoryIds', 'categoryIdList');
			}
			if (property === 'collectionIds') {
				renameFieldParams(filters, newFilters, 'collectionIds', 'collectionIdList');
			}
			if (property === 'supplierCategoryList') {
				renameFieldParams(filters, newFilters, 'supplierCategoryList', 'fabricTypeList');
			}
			if (property === 'blockCategory') {
				renameFieldParams(filters, newFilters, 'blockCategory', 'subCategoryIdList');
			}
			if (property === 'marketIds') {
				renameFieldParams(filters, newFilters, 'marketIds', 'marketIdList');
			}
			if (property === 'suppliers') {
				renameFieldParams(filters, newFilters, 'suppliers', 'supplierIdList');
			}
			if (property === 'requestByIds') {
				renameFieldParams(filters, newFilters, 'requestByIds', 'requestedByIdList');
			}
			if (property === 'requestDate') {
				formatDateParams(filters, newFilters, 'requestDate', 'requestedDateStart');
			}
			if (property === 'requiredDate') {
				formatDateParams(filters, newFilters, 'requiredDate');
			}
			if (property === 'costingStatusList') {
				renameFieldParams(filters, newFilters, 'costingStatusList', 'quoteStatusList');
			}
			if (property === 'fabricTypeList') {
				renameFieldParams(filters, newFilters, 'fabricTypeList', 'fabricTypes');
			}
			if (property === 'publishDate') {
				formatDateParams(filters, newFilters, 'publishDate', 'publishDateForCosting');
			}
			if (property === 'lastModifiedDate') {
				formatDateParams(filters, newFilters, 'lastModifiedDate');
			}
		}
	}

	if (newFilters.constructions) {
		newFilters.constructionList = newFilters.constructions;
		delete newFilters.constructions;
	}

	if (newFilters.fabricCompositionPartSearchDtoList) {
		newFilters.compositionPartDTOList = newFilters.fabricCompositionPartSearchDtoList;
		delete newFilters.fabricCompositionPartSearchDtoList;
	}

	if (newFilters.subCategoryIdList) {
		newFilters.subCategoryIdList = newFilters.subCategoryIdList.filter(
			(id) => !id.toString().includes('ALL')
		);
	}

	if (status) {
		newFilters['status'] = status;
	}
	newFilters['sort'] = sortId;
	return { ...newFilters };
};

const generateCostingDetailsParams = (allFilters) => {
	const filters = allFilters?.DETAILS_PAGE_FILTERS;
	let newFilters = {};
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
			if (property === 'requiredDate') {
				formatDateParams(filters, newFilters, 'requiredDate');
			}
			if (property === 'costingStatusList') {
				renameFieldParams(filters, newFilters, 'costingStatusList', 'statusList');
			}
			if (property === 'fabricTypeList') {
				renameFieldParams(filters, newFilters, 'fabricTypeList', 'fabricTypes');
			}
		}
	}
	return { ...newFilters };
};

const generatePomListParams = (filters, page) => {
	let newFilters = { page, size: 20, inProductMeasurementPage: false };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
		}
		if (property === 'brandIds') {
			renameFieldParams(filters, newFilters, 'brandIds', 'brandIdList');
		}
		if (property === 'categoryIds') {
			renameFieldParams(filters, newFilters, 'categoryIds', 'subCategoryIdList');
		}
		if (property === 'marketIds') {
			renameFieldParams(filters, newFilters, 'marketIds', 'marketIdList');
		}
	}
	if (!filters.sort) {
		newFilters['sort'] = 'serial';
	}

	return { ...newFilters };
};

const generateBlockLibraryListParams = (filters, page, sortId = 'id,desc') => {
	let newFilters = { page, size: 20 };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
		}
		if (property === 'blockCategory') {
			renameFieldParams(filters, newFilters, 'blockCategory', 'categoryIds');
		}
	}

	if (newFilters.categoryIds) {
		newFilters.categoryIds = newFilters.categoryIds.filter((id) => !id.toString().includes('ALL'));
	}

	newFilters['sort'] = sortId;
	return { ...newFilters };
};

const generateBlockLibraryCollectionListParams = (filters, page, sortId = 'id,desc') => {
	let newFilters = { page, size: 20, isBlock: true };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
		}
		if (property === 'brandIds') {
			renameFieldParams(filters, newFilters, 'brandIds', 'brandIdList');
		}
		if (property === 'createdByIds') {
			renameFieldParams(filters, newFilters, 'createdByIds', 'createdByIdList');
		}
	}
	newFilters['sort'] = sortId;
	return { ...newFilters };
};

const generateSketchListParams = (filters, page, sortId = 'id,desc') => {
	let newFilters = { page, size: 20 };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
		}
		if (property === 'blockCategory') {
			renameFieldParams(filters, newFilters, 'blockCategory', 'categoryIds');
		}
	}

	if (newFilters.categoryIds) {
		newFilters.categoryIds = newFilters.categoryIds.filter((id) => !id.toString().includes('ALL'));
	}

	newFilters['sort'] = sortId;
	return { ...newFilters };
};

const generateArtworkListParams = (filters, page = 0, sortId = 'id,desc') => {
	let newFilters = { page, size: 20 };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
		}
		if (property === 'colorList') {
			renameFieldParams(filters, newFilters, 'colorList', 'pantoneColorIds');
		}
	}

	newFilters['sort'] = sortId;
	return { ...newFilters };
};

const formatDate = (date) => {
	const parsedDate = new Date(date);
	const year = parsedDate.getFullYear();
	const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
	const day = String(parsedDate.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

const generateArtworkFilterParams = (filtersFields, page = 0, sortId = 'id,desc') => {
	let newFilters = {};
	for (const property in filtersFields) {
		if (Array.isArray(filtersFields[property])) {
			newFilters[property] = filtersFields[property].map((item) => item.key);
		}
		if (property === 'seasonList') {
			renameFieldParams(filtersFields, newFilters, 'seasonList', 'seasonTagIds');
		}
		if (property === 'themeList') {
			renameFieldParams(filtersFields, newFilters, 'themeList', 'artworkThemeTagIds');
		}
		if (property === 'DESIGN_BY') {
			renameFieldParams(filtersFields, newFilters, 'DESIGN_BY', 'designedByIds');
		}
		if (property === 'CREATED_BY') {
			renameFieldParams(filtersFields, newFilters, 'CREATED_BY', 'createdByIds');
		}
		if (property === 'creationDate') {
			const startDate = filtersFields[property][0]?.key?.split(',')[0];
			const endDate = filtersFields[property][0]?.key?.split(',')[1];

			if (startDate) {
				const parsedStartDate = new Date(startDate);
				const createDateFormat = formatDate(parsedStartDate);
				newFilters.startDate = createDateFormat;
			}
			if (endDate) {
				const parsedEndDate = new Date(endDate);
				const createDateFormat = formatDate(parsedEndDate);
				newFilters.endDate = createDateFormat;
			}
			delete newFilters.creationDate;
		}
	}
	if (sortId) {
		if (sortId === 'lastResponseTime,desc') {
			newFilters['sort'] = 'modifiedAt';
		} else {
			newFilters['sort'] = sortId;
		}
	}
	if (page) {
		newFilters['page'] = page;
		newFilters['size'] = 20;
	}

	return { ...newFilters };
};

const generateCollectionListParams = (filters, page, sortId = 'id,desc') => {
	let newFilters = { page, size: 12 };
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			if (filters[property][0]?.value === 'ARCHIVED') {
				newFilters.isArchived = true;
			} else {
				newFilters[property] = filters[property].map((item) => {
					if (item.type === 'SELECT') {
						return item.value;
					} else {
						return item.key;
					}
				});
			}
		}
		if (property === 'brandIds') {
			renameFieldParams(filters, newFilters, 'brandIds', 'brandIdList');
		}
		if (property === 'createdByIds') {
			renameFieldParams(filters, newFilters, 'createdByIds', 'createdByIdList');
		}
		if (property === 'creationDate') {
			formatDateParams(filters, newFilters, 'creationDate');
		}
	}

	newFilters['sort'] = sortId;
	return { ...newFilters };
};

const generateFavouriteListParams = (filters) => {
	let newFilters = {};
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
		}
		if (property === 'brandIds') {
			renameFieldParams(filters, newFilters, 'brandIds', 'brandIdList');
		}
		if (property === 'createdByIds') {
			renameFieldParams(filters, newFilters, 'createdByIds', 'createdByIdList');
		}
		if (property === 'filterCategoryList') {
			renameFieldParams(filters, newFilters, 'filterCategoryList', 'folderCategoryList');
		}
		if (property === 'creationDate') {
			formatDateParams(filters, newFilters, 'creationDate');
		}
	}

	return { ...newFilters };
};

const generateProductListParams = (filters, sortId = 'id,desc') => {
	let newFilters = {};

	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			if (property === 'availabilityStatusList' && filters[property][0]?.value === 'ARCHIVED') {
				newFilters.isArchived = true;
			}
			if (property === 'availabilityStatusList') {
				delete newFilters.availabilityStatusList;
			}
			if (property === 'referenceNumber') {
				newFilters[property] = filters[property].map((item) => item?.value).join(',');
			} else if (property === 'sampleIdentificationNo') {
				newFilters[property] = filters[property]?.map((item) => item?.value).join(',');
			} else if (property === 'constructions') {
				newFilters[property] = filters[property].map((item) => item?.value);
			} else {
				if (property === 'offerPriceList') {
					// Use a Map to store the latest entry for each brandId
					const offerPriceMap = new Map();
					filters[property].forEach((item) => {
						if (item?.brandId) {
							offerPriceMap.set(item.brandId, {
								minPrice: item?.minPrice,
								maxPrice: item?.maxPrice,
								brandId: item?.brandId
							});
						}
					});
					// Convert the Map values to an array
					newFilters[property] = Array.from(offerPriceMap.values());
				} else {
					newFilters[property] = filters[property].map((item) => {
						if (item.type === 'SELECT') {
							return item.value;
						} else if (property === 'PRODUCT_PRICE_RANGE') {
							newFilters.productionMinPrice = item?.minPrice;
							newFilters.productionMaxPrice = item?.maxPrice;
						} else {
							return item.key;
						}
					});
				}
			}

			if (property === 'marketIds') {
				renameFieldParams(filters, newFilters, 'marketIds', 'marketIdList');
			}
			if (property === 'brandIds') {
				renameFieldParams(filters, newFilters, 'brandIds', 'brandIdList');
			}
			if (property === 'blockCategory') {
				renameFieldParams(filters, newFilters, 'blockCategory', 'subCategoryIdList');
			}
			if (property === 'CREATED_BY') {
				renameFieldParams(filters, newFilters, 'CREATED_BY', 'createdByIdList');
			}
			if (property === 'DESIGN_BY') {
				renameFieldParams(filters, newFilters, 'DESIGN_BY', 'designedByIdList');
			}
			if (property === 'TP_COMPLETED_BY') {
				renameFieldParams(filters, newFilters, 'TP_COMPLETED_BY', 'tpCompletedByIdList');
			}
			if (property === 'creationDate') {
				formatDateParams(filters, newFilters, 'creationDate', 'creationDateForProduct');
			}
			if (property === 'publishDate') {
				formatDateParams(filters, newFilters, 'publishDate');
			}
			if (property === 'taskGroupFromDate') {
				newFilters.taskGroupFromDate = filters[property][0]?.key;
			}
			if (property === 'taskGroupToDate') {
				newFilters.taskGroupToDate = filters[property][0]?.key;
			}
			if (property === 'soldDate') {
				const soldDateValue = filters[property]?.[0]?.key;
				if (soldDateValue) {
					const [soldFromDate, soldToDate] = soldDateValue.split(',');
					if (soldFromDate && soldFromDate !== 'null') {
						newFilters.soldFromDate = soldFromDate;
					}
					if (soldToDate && soldToDate !== 'null') {
						newFilters.soldToDate = soldToDate;
					}
				}
				delete newFilters[property];
			}
		}
	}

	if (newFilters.constructions) {
		newFilters.constructionList = newFilters.constructions;
		delete newFilters.constructions;
	}
	if (newFilters.subCategoryIdList) {
		newFilters.subCategoryIdList = newFilters.subCategoryIdList.filter(
			(id) => !id.toString().includes('ALL')
		);
	}

	delete newFilters['PRODUCT_PRICE_RANGE'];

	newFilters['sort'] = sortId;

	if (newFilters.isArchived) {
		delete newFilters.availabilityStatusList;
	}

	return { ...newFilters };
};

const allFilterPages = {
	SAMPLE_LIST: 'SAMPLE_LIST',
	SUPPLIER_LIST: 'SUPPLIER_LIST',
	SALES_FUNNEL_LIST: 'SALES_FUNNEL_LIST',
	SAMPLE_DETAILS: 'SAMPLE_DETAILS',
	COSTING_LIST: 'COSTING_LIST',
	COSTING_DETAILS: 'COSTING_DETAILS',
	INITIAL_COSTING_LIST: 'INITIAL_COSTING_LIST',
	POM_LIST: 'POM_LIST',
	BLOCK_LIBRARY_CARD_VIEW_LIST: 'BLOCK_LIBRARY_CARD_VIEW_LIST',
	BLOCK_LIBRARY_COLLECTION_VIEW_LIST: 'BLOCK_LIBRARY_COLLECTION_VIEW_LIST',
	BLOCK_SUGGESTIONS: 'BLOCK_SUGGESTIONS',
	SKETCH_LIST: 'SKETCH_LIST',
	ARTWORK_LIST: 'ARTWORK_LIST',
	MY_COLLEAGUES: 'MY_COLLEAGUES',
	FABRIC_LIST_TAB: 'FABRIC_LIST_TAB',
	COLLECTION_LIST: 'COLLECTION_LIST',
	PRODUCT_LIST: 'PRODUCT_LIST',
	TRIMS_LIST_TAB: 'TRIMS_LIST_TAB',
	COLLECTION_DETAILS: 'COLLECTION_DETAILS',
	CLIENT_LIST: 'CLIENT_LIST',
	FAVOURITE_LIST: 'FAVOURITE_LIST',
	FAVOURITE_DETAILS: 'FAVOURITE_DETAILS',
	MY_ORDER: 'MY_ORDER',
	PROJECT_DETAILS: 'PROJECT_DETAILS',
	TREND_RESEARCH: 'TREND_RESEARCH',
	ARTBOARD_LIST: 'ARTBOARD_LIST',
	MATERIAL_REQUISITION: 'MATERIAL_REQUISITION',
	INVENTORY_UPDATE: 'INVENTORY_UPDATE',
	MY_PROJECTS: 'MY_PROJECTS',
	LAST_STATUS: 'LAST_STATUS',
	STYLE_TRACKER: 'STYLE_TRACKER'
};

const allDetailsPages = ['SAMPLE_DETAILS', 'COSTING_DETAILS'];

const removeQueryParams = (url) => {
	const urlParts = url.split('?');
	return urlParts[0];
};
const isDetailsPage = () => {
	const currentUrl = removeQueryParams(window.location.href);
	const parts = currentUrl.split('/');
	const lastSegment = parts[parts.length - 1];
	return (
		/^\d+$/.test(lastSegment) &&
		!currentUrl.includes('designs/edit/') &&
		!currentUrl.includes('brand/profile')
	);
};

const renameKeys = (key) => {
	return key === 'blockCreatedById' ? 'createdByIds' : key === 'blockCategory' ? 'subCategoryIds' : key;
};

const formatFilterFields = (fields) => {
	const selectedFields = {};
	for (let property in fields) {
		if (property !== 'DETAILS_PAGE_FILTERS') {
			const renamedKey = renameKeys(property);
			selectedFields[renamedKey] = fields[property];
		}
	}
	return selectedFields;
};

const generateBlockSuggestionsParams = ({
	fields = {},
	page = 0,
	id,
	search = '',
	addSearch = true,
	blockListTab
}) => {
	const formatFilter = formatFilterFields(fields);
	let params = '';

	Object.keys(formatFilter).forEach((key) => {
		if (Array.isArray(formatFilter[key])) {
			const values = formatFilter[key].filter((item) => item.checked).map((item) => item.key);

			if (values.length > 0) {
				if (params.length > 0) {
					params += '&';
				}
				params += `${key}=${values.filter((value) => !value.toString().includes('ALL')).join(',')}`;
			}
		}
	});

	const isBlock = blockListTab === 'BLOCKS_LIST';

	return addSearch
		? `?productId=${id}&page=${page}&size=20${
				params ? `&${params}` : ''
			}&search=${search}&isBlock=${isBlock}`
		: `?productId=${id}${params ? `&${params}` : ''}&isBlock=${isBlock}`;
};

const generateCRMDashboardParams = (filters, isAddDateRange = true) => {
	let newFilters = {};
	for (const property in filters) {
		if (Array.isArray(filters[property])) {
			newFilters[property] = filters[property].map((item) => item.key);
			if (property === 'dateRange' && isAddDateRange) {
				formatDateParams(filters, newFilters, 'dateRange');
			}
		}
	}
	if (filters?.name?.[0]?.key) {
		newFilters['search'] = filters?.name[0]?.key;
		delete newFilters['name'];
	}
	return { ...newFilters };
};

const getInitialDataBasedOnLevel = (dataLevel, multiLevelFilterStore) =>
	multiLevelFilterStore?.multiLevelFilters?.find((item) => item?.filterLevel === dataLevel)?.subCategory;

// Recursive function to find the subCategory
const findSubCategoryBasedOnLabel = (listOfData, searchKey) => {
	const filterData = (data) => {
		return data.reduce((acc, item) => {
			let newItem = { ...item };
			if (newItem.name.toLowerCase().includes(searchKey)) {
				acc.push(newItem);
				return acc;
			}

			if (newItem.subCategory) {
				let filteredSubCategory = filterData(newItem.subCategory);
				if (filteredSubCategory.length > 0) {
					newItem.subCategory = filteredSubCategory;
					acc.push(newItem);
				}
			}

			return acc;
		}, []);
	};
	return filterData(listOfData);
};

const getFilteredCurrentDataBasedOnLevel = (dataLevel, selectedMultilevelData, searchKey) => {
	const multiLevelFiltersData = selectedMultilevelData?.find(
		(item) => item?.filterLevel === dataLevel
	)?.subCategory;

	if (searchKey) {
		return findSubCategoryBasedOnLabel(multiLevelFiltersData, searchKey);
	} else {
		return multiLevelFiltersData;
	}
};

const handleFilterItemSearch = (
	e,
	allData = [],
	setData,
	updateSelectedOptionBasedOnSearch,
	hasFourthLayer = false
) => {
	const query = e.target.value.toLowerCase();

	const searchResult = findSubCategoryBasedOnLabel(allData, query);
	updateSelectedOptionBasedOnSearch(3, searchResult[0]);
	// For Fourth layer auto select on search
	hasFourthLayer && updateSelectedOptionBasedOnSearch(4, searchResult[0]?.subCategory[0]);
	setData(searchResult);
};

// used in FabricTypeV2.js to search multi layer filter fields.
// common filter Search handler
const handleFourthLevelSearch = (
	e,
	levelNo,
	multiLevelFilterStore,
	selectedMultilevelData,
	setSelectedMultiLevelData
) => {
	let thirdLayerSearchResult = e.target.value
		? getInitialDataBasedOnLevel(levelNo, multiLevelFilterStore)?.filter((item) =>
				item?.name?.toLowerCase().includes(e.target.value.toLowerCase())
			)
		: getInitialDataBasedOnLevel(levelNo, multiLevelFilterStore);

	let filteredData = selectedMultilevelData?.map((item) => {
		if (item?.filterLevel === levelNo) {
			return {
				...item,
				subCategory: thirdLayerSearchResult
			};
		} else return item;
	});
	setSelectedMultiLevelData(filteredData);
};

const generateFilterFabricParams = (filterFields) => {
	let filterKeys = {};
	for (const property in filterFields) {
		if (Array.isArray(filterFields[property])) {
			filterKeys[property] = filterFields[property].map((item) => {
				if (property === 'fabricCompositionPartSearchDtoList') {
					return {
						minPercentage: item?.minPercentage,
						maxPercentage: item?.maxPercentage,
						fiberName: item?.fiberName
					};
				} else if (property === 'colorGroupList') {
					const key = item?.key;
					if (key && key.includes('__')) {
						const [colorGroupId, colorType] = key.split('__');
						return {
							colorGroupId,
							colorType
						};
					}
				} else if (property === 'constructions') {
					return item.value;
				} else if (property === 'countryIds') {
					return parseInt(item?.key);
				} else if (property === 'baseList') {
					return item?.key;
				} else if (property === 'FABRIC_PRICE_RANGE') {
					filterKeys.minPrice = item?.minPrice;
					filterKeys.maxPrice = item?.maxPrice;
				} else if (property === 'FABRIC_BALANCE') {
					filterKeys.minBalanceQuantity = item?.minPrice;
					filterKeys.maxBalanceQuantity = item?.maxPrice;
				} else if (property === 'IS_IMPORTED') {
					filterKeys.isImported = [item?.categoryId];
				} else if (property === 'dateRange') {
					filterKeys.materialNotBookedSince = item.key.split(',')[0];
				} else if (property === 'WEIGHT') {
					filterKeys.minGsm = item?.minGsm;
					filterKeys.maxGsm = item?.maxGsm;
				} else {
					return item.key;
				}
			});
		}
	}
	if (filterKeys.colorGroupList) {
		filterKeys.colorGroupList = filterKeys.colorGroupList.filter((value) => value !== undefined);
	}
	if (filterKeys.subCategoryIds) {
		filterKeys.subCategoryIds = filterKeys.subCategoryIds.filter((id) => !id.toString().includes('ALL'));
	}
	if (filterKeys.fabricPatternIds) {
		filterKeys.fabricPatternIds = filterKeys.fabricPatternIds.filter(
			(id) => !id.toString().includes('ALL')
		);
	}

	delete filterKeys['WEIGHT'];
	delete filterKeys['FABRIC_PRICE_RANGE'];
	delete filterKeys['FABRIC_BALANCE'];
	delete filterKeys['IS_IMPORTED'];
	delete filterKeys['NITEX_REFERENCE'];
	delete filterKeys['dateRange'];

	if (filterKeys['search']) {
		filterKeys['search'] = filterKeys['search']?.join('');
	}
	if (filterKeys['nitexReferenceNumber']) {
		filterKeys['nitexReferenceNumber'] = filterKeys['nitexReferenceNumber']?.join('');
	}
	if (filterKeys['supplierReferenceNumber']) {
		filterKeys['supplierReferenceNumber'] = filterKeys['supplierReferenceNumber']?.join('');
	}
	return filterKeys;
};

const formatMultiLayerFilteOptions = (responseData) => {
	responseData = responseData?.map((item, idx) => {
		if (item?.parentCatergory) {
			return {
				id: `${idx}_${item?.parentCatergory}`,
				name: item?.parentCatergory,
				count: item?.count,
				label: 2,
				subCategory: item?.categoryEntityCountList?.map((subItem) => ({
					...subItem,
					label: 3,
					subCategory: [
						{
							name: 'All',
							id: `${subItem?.id}-ALL`,
							count: subItem?.count,
							categoryId: subItem?.id,
							label: 4
						},
						...(subItem?.subCategoryEntityCountList?.map((item) => ({
							...item,
							label: 4
						})) || [])
					]
				}))
			};
		} else {
			const { id, count, name, subCategoryEntityCountList } = item;
			return {
				id,
				count,
				name,
				label: 2,
				subCategory: subCategoryEntityCountList
					? [
							{
								name: 'All',
								id: `${item?.id}-ALL`,
								count: item?.count,
								categoryId: item?.id,
								label: 3
							},
							...subCategoryEntityCountList.map((item) => ({
								...item,
								label: 3
							}))
						]
					: []
			};
		}
	});
	return responseData;
};

const formatMultilayerColorsOptions = (responseData) => {
	return responseData?.map((item) => {
		const { count, colorType, colorGroupEntityCountList } = item;

		const formattedColorGroupEntityCountList = colorGroupEntityCountList?.map((color) => ({
			...color,
			id: `${color.id}__${colorType}`,
			hexCode: color.additionalInfo
		}));

		return {
			count,
			name: colorType,
			id: colorType,
			subCategory: formattedColorGroupEntityCountList
				? [
						{
							name: 'All',
							id: 'ALL',
							count: item?.count
						},
						...formattedColorGroupEntityCountList
					]
				: []
		};
	});
};

const formatMaterialCategoryOptions = (responseData) => {
	return responseData?.map((item) => {
		const { count, name, constant, subCategoryList } = item;

		return {
			count,
			name,
			id: constant,
			subCategory: subCategoryList
				? [
						{
							name: 'All',
							id: 'ALL',
							count: item?.count
						},
						...subCategoryList
					]
				: []
		};
	});
};

const formatStyleTrakerOptions = (responseData = []) => {
	return responseData
		?.filter((firstLayer) => firstLayer?.count > 0)
		?.map((item) => {
			const { count = 0, name = '', constant = '', enumCountList = [] } = item || {};

			const subCategory = enumCountList.length
				? [
						{
							name: 'All',
							id: 'ALL',
							count
						},
						...enumCountList.map((enumItem) => ({
							...enumItem,
							id: enumItem?.constant ?? ''
						}))
					]
				: [];

			return {
				count,
				name,
				id: constant,
				subCategory
			};
		});
};

const formatRangeValue = (filterName, symble = '', symblePosition = 'right') => {
	const formatValue = (value) => {
		if (symblePosition === 'left') {
			return `${symble}${value}`;
		} else {
			return `${value}${symble}`;
		}
	};

	if (filterName.min && !filterName.max) {
		return `Min ${formatValue(filterName.min)}`;
	} else if (!filterName.min && filterName.max) {
		return `Max ${formatValue(filterName.max)}`;
	} else if (filterName.min && filterName.max) {
		return `${formatValue(filterName.min)} - ${formatValue(filterName.max)}`;
	}

	return '';
};

const formatLocationOptions = (responseData) => {
	return responseData?.map((item) => ({
		...item,
		id: item.id,
		name: item.buildingName,
		subCategory: [
			...item.floorList?.map((floor) => ({
				...floor,
				id: floor.id,
				name: floor.floorName,
				subCategory: [
					{
						name: 'All',
						id: 'ALL',
						count: floor?.count
					},
					...floor.colorList?.map((color) => ({
						...color
					}))
				]
			}))
		]
	}));
};

const TEAM_FILTER_OPTIONS = [
	{
		name: 'Created By',
		id: 'CREATED_BY',
		constant: 'CREATED_BY',
		subCategoryResponseName: 'createdByList',
		subCategory: []
	},
	{
		name: 'Design By',
		id: 'DESIGN_BY',
		constant: 'DESIGN_BY',
		subCategoryResponseName: 'designedByList',
		subCategory: []
	},
	{
		name: 'TP Completed By',
		id: 'TP_COMPLETED_BY',
		constant: 'TP_COMPLETED_BY',
		subCategoryResponseName: 'tpCompletedByList',
		subCategory: []
	},
	{
		name: 'Added to Favourite By',
		id: 'ADDED_TO_FAVOURITE_BY',
		constant: 'ADDED_TO_FAVOURITE_BY',
		subCategoryResponseName: 'addedToFavByList',
		subCategory: []
	}
];

const DATE_GROUP_FILTER_OPTIONS = [
	{
		name: 'PO Received Date',
		id: 'PO_RECEIVED_DATE',
		constant: 'PO_RECEIVED_DATE',
		subCategoryResponseName: 'poReceivedDate',
		subCategory: []
	},
	{
		name: 'Buyer ETD',
		id: 'BUYER_ETD',
		constant: 'BUYER_ETD',
		subCategoryResponseName: 'buyerEtd',
		subCategory: []
	},
	{
		name: 'Factory ETD',
		id: 'FACTORY_ETD',
		constant: 'FACTORY_ETD',
		subCategoryResponseName: 'factoryDate',
		subCategory: []
	},
	{
		name: 'Ex Factory Date',
		id: 'EX_FACTORY_DATE',
		constant: 'EX_FACTORY_DATE',
		subCategoryResponseName: 'exFactoryDate',
		subCategory: []
	}
];

const formatTeamOptions = (responseData) => {
	return TEAM_FILTER_OPTIONS?.map((item) => ({
		...item,
		subCategory: responseData[item?.subCategoryResponseName]?.map((subItem) => ({
			...subItem,
			constant: item?.constant
		}))
	}));
};

const formatDateGroupOptions = () => {
	return DATE_GROUP_FILTER_OPTIONS?.map((item) => ({
		...item,
		subCategory: []
	}));
};

const createDateFilterParams = (filterFields) => {
	const dateParam = {};

	const dateFieldMappings = {
		CREATION_DATE: {
			fromKey: 'creationFromDate',
			uptoKey: 'creationUptoDate'
		},
		SAMPLE_COMPLETED_DATE: {
			fromKey: 'sampleCreationFromDate',
			uptoKey: 'sampleCreationUptoDate'
		},
		ADD_TO_FAVOURITE_DATE: {
			fromKey: 'addedToFavFromDate',
			uptoKey: 'addedToFavUptoDate'
		}
	};

	Object.entries(filterFields).forEach(([key, value]) => {
		if (dateFieldMappings[key]) {
			const [fromDate, uptoDate] = value?.[0]?.key?.split(',') || [];
			const { fromKey, uptoKey } = dateFieldMappings[key];
			dateParam[fromKey] = fromDate;
			dateParam[uptoKey] = uptoDate;
		}
	});

	return dateParam;
};
export const getFilterParams = (filterFields, id, key, isFavouritePage = false) => {
	let filterParams = {
		[key]: id
	};
	const bodyObj = {};
	let params = '';

	const filterMappings = {
		blockCategory: {
			paramKey: 'subCategoryIdList',
			transform: getFilteredKeyList
		},
		marketIds: {
			paramKey: 'marketIdList',
			transform: getFilteredKeyList
		},
		constructions: {
			paramKey: 'constructionList',
			transform: (items) =>
				items?.filter((item) => item?.value && !isAllLikeValue(item.value))?.map((item) => item.value)
		},
		tagIds: {
			paramKey: 'tagIdList',
			transform: getFilteredKeyList
		},
		PRODUCT_PRICE_RANGE: {
			transform: (fields) => ({
				productionMinPrice: fields[0]?.key?.min,
				productionMaxPrice: fields[0]?.key?.max
			})
		},
		collectionLocationList: {
			paramKey: 'sampleInventoryLocationIdList',
			transform: getFilteredKeyList
		},
		CREATED_BY: {
			paramKey: 'createdByIdList',
			transform: getFilteredKeyList
		},
		DESIGN_BY: {
			paramKey: 'designedByIdList',
			transform: getFilteredKeyList
		},
		TP_COMPLETED_BY: {
			paramKey: 'tpCompletedByIdList',
			transform: getFilteredKeyList
		},
		ADDED_TO_FAVOURITE_BY: {
			paramKey: 'addedToFavByIdList',
			transform: getFilteredKeyList
		},
		collectionIds: {
			paramKey: 'collectionIdList',
			transform: getFilteredKeyList
		},
		referenceNumber: {
			paramKey: 'referenceNumber',
			transform: (items) => items?.map((item) => item.key).join(',')
		},
		availabilityStatusList: {
			paramKey: 'availabilityStatusList',
			transform: (items) =>
				items?.filter((item) => item?.value && !isAllLikeValue(item.value))?.map((item) => item.value)
		},
		locationUpdateStatusList: {
			paramKey: 'locationUpdateStatusList',
			transform: (items) => items?.map((item) => item.key)
		}
	};

	const dateFilterParams = createDateFilterParams(filterFields);

	filterParams = { ...filterParams, ...dateFilterParams };

	// Handle special case for taskGroupFromDate and taskGroupToDate
	let taskGroupFromDateArr = [];
	let taskGroupToDateArr = [];
	if (filterFields && (filterFields.taskGroupFromDate || filterFields.taskGroupToDate)) {
		// If these fields are present as arrays, join their keys
		if (Array.isArray(filterFields.taskGroupFromDate)) {
			taskGroupFromDateArr = filterFields.taskGroupFromDate.map((item) => item.key).filter(Boolean);
		}
		if (Array.isArray(filterFields.taskGroupToDate)) {
			taskGroupToDateArr = filterFields.taskGroupToDate.map((item) => item.key).filter(Boolean);
		}
		// If present as single value, treat as array of one
		if (typeof filterFields.taskGroupFromDate === 'object' && filterFields.taskGroupFromDate?.key) {
			taskGroupFromDateArr = [filterFields.taskGroupFromDate.key];
		}
		if (typeof filterFields.taskGroupToDate === 'object' && filterFields.taskGroupToDate?.key) {
			taskGroupToDateArr = [filterFields.taskGroupToDate.key];
		}
		// If present as string, treat as array of one
		if (typeof filterFields.taskGroupFromDate === 'string') {
			taskGroupFromDateArr = [filterFields.taskGroupFromDate];
		}
		if (typeof filterFields.taskGroupToDate === 'string') {
			taskGroupToDateArr = [filterFields.taskGroupToDate];
		}
		if (taskGroupFromDateArr.length > 0) {
			filterParams.taskGroupFromDate = taskGroupFromDateArr.join(',');
		}
		if (taskGroupToDateArr.length > 0) {
			filterParams.taskGroupToDate = taskGroupToDateArr.join(',');
		}
	}

	Object.entries(filterFields).forEach(([key, value]) => {
		if (value == null) return;

		// if (key === 'taskGroupFromDate' || key === 'taskGroupToDate') return;

		const mapping = filterMappings[key];

		if (mapping) {
			const transformed = mapping.transform(value);

			if (mapping.paramKey) {
				filterParams[mapping.paramKey] = transformed;
			} else {
				Object.assign(filterParams, transformed);
			}
		} else {
			if (key === 'taskGroupFromDate') {
				filterParams.taskGroupFromDate = filterParams[key];
			} else if (key === 'taskGroupToDate') {
				filterParams.taskGroupToDate = filterParams[key];
			} else {
				filterParams[key] = value?.length ? getFilteredKeyList(value) : [];
			}
		}
	});

	delete filterParams.DETAILS_PAGE_FILTERS;
	delete filterParams.dateList;
	delete filterParams.clearOne;
	delete filterParams.clearAll;
	delete filterParams.CREATION_DATE;
	delete filterParams.SAMPLE_COMPLETED_DATE;
	delete filterParams.ADD_TO_FAVOURITE_DATE;

	if (isFavouritePage) {
		delete filterParams.sampleIdentificationNo;
		delete filterParams.productIdList;
	}

	// Build both params string and body object
	for (let field in filterParams) {
		if (Array.isArray(filterParams[field])) {
			// Special handling for task group date fields - join array to string
			params += `&${field}=${encodeURIComponent(filterParams[field].join(','))}`;
			bodyObj[field] = filterParams[field];
		} else if (
			field === 'productionMinPrice' ||
			field === 'productionMaxPrice' ||
			field === 'creationFromDate' ||
			field === 'creationUptoDate' ||
			field === 'sampleCreationFromDate' ||
			field === 'sampleCreationUptoDate' ||
			field === 'addedToFavFromDate' ||
			field === 'addedToFavUptoDate' ||
			field === 'referenceNumber' ||
			field === 'taskGroupFromDate' ||
			field === 'taskGroupToDate'
		) {
			params += `&${field}=${encodeURIComponent(filterParams[field])}`;
			bodyObj[field] = filterParams[field];
		}
	}

	return { filterParams, params, body: bodyObj };
};

function isAllLikeValue(value) {
	if (value === null || value === undefined) return false;
	const str = String(value).trim();
	if (!str) return false;
	const upper = str.toUpperCase();
	// Some filters use "ALL" as a sentinel option, and some use "<id>-ALL" for "select all within <id>".
	return upper === 'ALL' || upper.endsWith('-ALL');
}

function getFilteredKeyList(items = []) {
	return items
		?.filter((item) => {
			if (!item?.key) return false;
			if (isAllLikeValue(item.key)) return false;
			return true;
		})
		.map((item) => item.key);
}

export {
	CRMTargetFilterFieldList,
	accessoriesWiseFilterList,
	adminPageFieldList,
	allDetailsPages,
	allFilterPages,
	arkworkListFields,
	blockLibraryCollectionFields,
	blockLibraryDesignFields,
	blockSuggestionsFilterFields,
	categoryTypeParamsBasedOnSupplier,
	clientListFields,
	collectionDetailsFieldList,
	collectionFieldList,
	collectionStatusList,
	costingDetailsFilterFields,
	costingListDesignStudioFields,
	costingListFilterFields,
	criteriaList,
	designFieldList,
	embellishmentList,
	fabricFilterFields,
	filterCategory,
	filterFieldType,
	projectDetailsFilterFields,
	formatLocationOptions,
	formatMaterialCategoryOptions,
	formatMultiLayerFilteOptions,
	formatMultilayerColorsOptions,
	formatRangeValue,
	formatTeamOptions,
	formatDateGroupOptions,
	generateArtworkListParams,
	generateBlockLibraryCollectionListParams,
	generateBlockLibraryListParams,
	generateBlockSuggestionsParams,
	generateCRMDashboardParams,
	generateCollectionListParams,
	generateCostingDetailsParams,
	generateCostingListParams,
	generateFilterFabricParams,
	generateFilterParams,
	generateOrderDashboardParams,
	generatePomListParams,
	generateProductListParams,
	generateSalesFunnelDashboardParams,
	generateSampleDetailsParams,
	generateSampleListParams,
	generateSketchListParams,
	generateSupplierListParams,
	generateTeamParams,
	getFilterTextFieldValue,
	getFilteredCurrentDataBasedOnLevel,
	getInitialDataBasedOnLevel,
	handleFilterItemSearch,
	handleFourthLevelSearch,
	initialCostingListFilterFields,
	isDetailsPage,
	isTeamFilterExist,
	myColleaguesFilterFields,
	objForBuyerEtdDateRange,
	objForDateRange,
	objForPODateRange,
	objForPublishDate,
	orderDashboardFieldList,
	orderPageFieldList,
	pomListFilterFields,
	publicCollections,
	salesFunnelFilterFields,
	sampleDetailsFilterFields,
	sampleListFilterFields,
	sketchListFields,
	statusList,
	supplierListFilterFields,
	supplierTypeWiseFieldParams,
	supplierTypeWiseList,
	teamPageFieldList,
	toggleCheckbox,
	trimWiseFilterList,
	trimsFilterFields,
	washingFilterList,
	orderDashboardPageList,
	trendResearchBrandFilterFieldList,
	trendResearchInstagramFilterFieldList,
	favouriteListFieldList,
	generateFavouriteListParams,
	generateArtworkFilterParams,
	materialRequisitionFilterFieldList,
	materialRequisitionTrimsAndAccessoriesFilterFieldList,
	myProjectsFilterFields,
	formatStyleTrakerOptions
};
